import { gql } from '@apollo/client';

export const COMPUTE_ASSESSMENT_OUTCOME = gql`
  mutation computeAssessmentOutcome($input: ComputeAssessmentOutcomeInput!) {
    outcome: computeAssessmentOutcome(input: $input) {
      siteAssessmentOutcome
      programmeAssessmentOutcome
    }
  }
`;
